import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import _diff from 'lodash/difference';
import inferAllHiddenNodes from './inferAllHiddenNodes';
import {MapCardConnector} from 'common/src/components/CLCardsMap/Canvas/Canvas.types';
import {NodeOutputData, Nodes} from 'common/src/modules/nodes/nodes.types';

export default function getNodesWithDisabledOutputButton(
  nodesOrder: number[],
  campaignNodes: Nodes,
  hiddenConnectors: MapCardConnector[],
) {
  const disabledNodesRecord: Record<number, Array<number>> = {};
  const currentInfferedHiddenNodes = inferAllHiddenNodes(hiddenConnectors, campaignNodes);

  nodesOrder.map((nodeId) => {
    const thisNode = campaignNodes[nodeId];
    disabledNodesRecord[thisNode.id] = [];

    if (!thisNode || !thisNode.outputs.filter((output) => output.nodeId !== NO_NODE_ID).length) {
      return disabledNodesRecord;
    }

    const connectedOutputs = thisNode.outputs.filter((output) => output.nodeId !== NO_NODE_ID);

    const connectorsForThisNode: MapCardConnector[] = connectedOutputs.map((output, index) => {
      return {
        outputNodeId: thisNode?.id,
        outputIdx: index,
        inputNodeId: output.nodeId,
        outputId: output.id,
      };
    });

    const hiddenNodesIfAllOutputsHidden = _diff(
      inferAllHiddenNodes([...hiddenConnectors, ...connectorsForThisNode], campaignNodes),
      currentInfferedHiddenNodes,
    );

    function doesHidingConnectorHideAnyNode(output: NodeOutputData, index: number): boolean {
      const connectorForThisOutput = {
        outputNodeId: thisNode.id,
        outputIdx: index,
        inputNodeId: output.nodeId,
        outputId: output.id,
      };

      return (
        _diff(
          inferAllHiddenNodes([...hiddenConnectors, connectorForThisOutput], campaignNodes),
          currentInfferedHiddenNodes,
        ).length === 0
      );
    }

    if (hiddenNodesIfAllOutputsHidden.length === 0) {
      //if has outputs, but inferred hidden don't exist, push all outputs
      disabledNodesRecord[thisNode.id] = connectedOutputs.map((output) => output.nodeId);
    } else {
      thisNode.outputs.forEach((output, index) => {
        if (output.nodeId !== NO_NODE_ID && doesHidingConnectorHideAnyNode(output, index)) {
          disabledNodesRecord[thisNode.id].push(output.nodeId);
        }
      });
    }
  });

  return disabledNodesRecord;
}
